import * as moment from 'moment';

export default class DateHandler {
  constructor(date: any, private baseCentury: number = 2000) {
    if (date instanceof Date) {
      this.date = moment(date).format(this.mask);
    } else {
      this.date = date ? (date as string).trim() : date;
    }
  }

  get isValid(): boolean {
    const date = this.formatDate(this.date, this.mask);
    return date !== null && moment(date, this.mask).isValid();
  }

  format(mask: string = null): string {
    return this.date === null ? '' : this.internalFormat(mask === null || mask === undefined ? this.mask : mask);
  }

  get month(): string {
    return this.date === null ? '' : this.internalFormat(this.monthMask);
  }

  get day(): string {
    return this.date === null ? '' : this.internalFormat(this.dayMask);
  }

  get year(): string {
    return this.date === null ? '' : this.internalFormat(this.yearMask);
  }

  private internalFormat(mask: string) {
    let date: string = null;

    if (!this.isValid) {
      date = this.formatDate(this.date, this.mask);
    } else {
      date = this.date;
    }
    return date === null || date.trim() === '' ? '' : moment(date, this.mask).format(mask);
  }

  private formatDate(date: string, mask: string): string {
    const dateNoDelimiters: string = date.replace(/\/|-/g, '');
    const maskNoDelimiters: string = mask.replace(/\/|-/g, '');
    const length = maskNoDelimiters.length - dateNoDelimiters.length;

    if (length < 0 || (length !== 2 && length !== 0)) {
      return null;
    }

    if (length === 2) {
      const year = parseInt(dateNoDelimiters.slice(-2), 10);
      date = `${date.slice(0, -2)}${year + this.baseCentury}`;
    }

    return date;
  }

  private date: string = null;
  private mask = 'MM/DD/YYYY';
  private dayMask = 'DD';
  private monthMask = 'MM';
  private yearMask = 'YYYY';
}



// WEBPACK FOOTER //
// ./src/models/dateHandler.ts